module.exports = __webpack_public_path__ + "img/carousel_rect.0d35965e.svg";